import { Chip } from '@/components/ui'
import {
  Check,
  FileText,
  ShoppingCart,
  Truck,
  X,
  type LucideIcon,
} from 'lucide-react'

const ACTION_META: Record<string, { icon: LucideIcon; label: string; variant: 'info' | 'success' | 'warning' | 'danger' | 'neutral' }> = {
  create_purchase_order: { icon: Truck, label: 'Create PO', variant: 'info' },
  create_sales_order: { icon: ShoppingCart, label: 'Create SO', variant: 'info' },
  confirm_order: { icon: Check, label: 'Confirm', variant: 'success' },
  cancel_order: { icon: X, label: 'Cancel', variant: 'danger' },
  create_invoice: { icon: FileText, label: 'Invoice', variant: 'info' },
}

export function ActionBadge({ action }: { action: string }) {
  const meta = ACTION_META[action]
  if (!meta) {
    return (
      <Chip size="xs" variant="neutral">
        {action}
      </Chip>
    )
  }
  const Icon = meta.icon
  return (
    <span className="inline-flex items-center gap-1.5">
      <Icon size={12} className="text-tertiary" aria-hidden="true" />
      <Chip size="xs" variant={meta.variant}>
        {meta.label}
      </Chip>
    </span>
  )
}
